import React, { memo } from 'react';
import { Remote } from '@okapi/remote';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, BreadcrumbsItem, Layout, Typography } from 'fronton-react';
import { categoriesList } from 'common/components';
import { CategoriesItem } from 'common/components/categories-list/categories-item';
import { SeoText } from 'common/components/seo-text';
import { useStoreContext } from 'store';
import { useEffectOnce } from 'common';
import { addSlashToEndString, analyticsUtils, patchUrlByLocale } from 'utils';
import { breadCrumbs } from './styles';
import { RecommendationsBrands } from './recommendations-brands';

export const DATA_QA_CATEGORY_CONTAINER = 'category-container';
export const CATALOG_TEMPLATE = 'catalog';

export const Catalogue = memo(() => {
  const store = useStoreContext();
  const { t } = useTranslation();
  const disableAppsflyer = !store?.env?.useAppsflyer;

  useEffectOnce(() => {
    analyticsUtils.sendEvent('GA:pageview', {
      pageType: 'Catalog', // тип страницы
      pagePath: `${addSlashToEndString(store?.router?.path)}${store?.router?.search}`, // путь к странице
    });
  });

  const { title, template } = store?.model?.data?.properties || {};

  const breadcrumb = t('breadcrumbs');

  function sendBreadcrumbAnalytics() {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementName: 'breadcrumbs',
      elementText: breadcrumb,
      elementBlock: breadcrumb,
    });
  }

  return (
    <>
      <Remote widget="header-footer/header" id="catalogue-header" data={{ disableAppsflyer }} />
      <Remote widget="basket-logic/basket-logic" id="basket-logic" />
      <Layout>
        <Breadcrumbs className={breadCrumbs}>
          <BreadcrumbsItem onClick={sendBreadcrumbAnalytics} href={patchUrlByLocale('/')}>
            {breadcrumb}
          </BreadcrumbsItem>
        </Breadcrumbs>
        <Typography variant="h1" data-qa="header" as="h1">
          {title || t('title')}
        </Typography>
        <RecommendationsBrands />
        {template === CATALOG_TEMPLATE && (
          <ul className={categoriesList} data-qa={DATA_QA_CATEGORY_CONTAINER}>
            {store?.catalogue?.data?.map((category) => (
              <React.Fragment key={category.label ?? category.name}>
                {category.isVisual && <CategoriesItem renderCount={5} {...category} />}
              </React.Fragment>
            ))}
          </ul>
        )}
      </Layout>
      <SeoText seoTextHTML={store?.model?.data?.seoProperties.seotext} />
      <Remote widget="header-footer/footer" id="catalogue-footer" />
    </>
  );
});
